export const ERROR_NOT_CONNECTED = "WEBSOCKET ERROR";
export const JACKPOT_ID = "jp-ex";
